import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProjectDto, ProjectResolved } from 'projects/shared/src/lib/models/Project';
import { PROJECTTABS, SquirrelTabs } from 'projects/shared/src/lib/models/SquirrelTabs';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'edit-project',
  templateUrl: './edit-project.component.html',
  styleUrls: ['./edit-project.component.scss']
})
export class EditProjectComponent implements OnInit {

  projectDto!:ProjectDto;
  tabs: SquirrelTabs[] = [];

  constructor(private route: ActivatedRoute,
    public translate: TranslateService) { }

  ngOnInit(): void {

    this.tabs = PROJECTTABS;

    this.route.data.subscribe({
      next: (data:any) => {
        const resolvedData: ProjectResolved = data['resolvedData'];
        this.projectDto = resolvedData.projectDto;
      },
      //error
    });
  }
}
